<script setup>
/**
 * GoogleMeetLogo — the official multi-color Meet camera mark, as inline SVG.
 * Rendering logos as inline SVG (rather than an <img>) means they scale
 * crisply at any size, can be styled, and add no extra network request.
 *
 * Set `withWordmark` to show the "Google Meet" text beside the mark (used in
 * the header); leave it off for a standalone icon.
 */
defineProps({
  size: { type: [Number, String], default: 40 },
  withWordmark: { type: Boolean, default: false },
})
</script>

<template>
  <span class="meet-logo" role="img" aria-label="Google Meet">
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 87.5 72"
      aria-hidden="true"
      focusable="false"
    >
      <path fill="#00832d" d="M49.5 36l8.53 9.75 11.47 7.33 2-17.02-2-16.64-11.69 6.44z" />
      <path fill="#0066da" d="M0 51.5V66c0 3.315 2.685 6 6 6h14.5l3-10.96-3-9.54-9.95-3z" />
      <path fill="#e94235" d="M20.5 0L0 20.5l10.55 3 9.95-3 2.95-9.41z" />
      <path fill="#2684fc" d="M0 20.5h20.5v31H0z" />
      <path
        fill="#00ac47"
        d="M82.6 8.68L69.5 19.42v33.66l13.16 10.79c1.97 1.54 4.84.13 4.84-2.37V11.05c0-2.53-2.95-3.92-4.9-2.37zM49.5 36v15.5h-29V72h43c3.315 0 6-2.685 6-6V53.08z"
      />
      <path fill="#ffba00" d="M63.5 0h-43v20.5h29V36l20-16.57V6c0-3.315-2.685-6-6-6z" />
    </svg>
    <span v-if="withWordmark" class="meet-logo__wordmark">
      <span class="meet-logo__google">Google</span> Meet
    </span>
  </span>
</template>

<style scoped>
.meet-logo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
}
.meet-logo__wordmark {
  font-family: var(--font-google);
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
}
.meet-logo__google {
  color: #5f6368;
}
[data-theme='dark'] .meet-logo__google {
  color: #9aa0a6;
}
</style>
